// Browser's session storage
export const SESSION_CHECK_USER_TIMEZONE_KEY = 'CheckUserTimeZone';
export const SESSION_ERROR_RECOVERY_STATE_KEY = 'errorRecoveryState';
export const SESSION_DEMO_STATE_KEY = 'demoMode';
export const SESSION_USER_CLOSED_MOBILE_APP_BANNER_KEY = 'userClosedMobileAppBanner';

// Browser's local storage
export const LOCAL_STORAGE_JWT_STORAGE_KEY = 'jwt';
export const LOCAL_STORAGE_LANGUAGE_STORAGE_KEY = 'language';
export const LOCAL_STORAGE_SELECTED_DIAGRAM_DATAPOINTS_KEY = 'selectedDiagramDataPoints';
export const LOCAL_STORAGE_SELECTED_STATISTICS_DATAPOINTS_KEY = 'selectedStatisticsDataPoints';
export const LOCAL_STORAGE_UI_THEME = 'uiTheme';

// BE user preferences
export const USER_PREFERENCE_DONT_SHOW_AGAIN_FOR_TZ_KEY = 'DONT_SHOW_AGAIN_FOR_TZ';
export const USER_PREFERENCE_LAST_COMPLETED_GUIDED_TOUR_KEY = 'LAST_COMPLETED_GUIDED_TOUR';
export const USER_PREFERENCE_COLOR_PALETTE = 'COLOR_PALETTE';
export const USER_PREFERENCE_COLOR_MAPPING_PREFIX = 'COLOR_MAPPING_';
export const USER_PREFERENCE_SW_LAST_VERSION = 'SW_LAST_VERSION';
export const USER_PREFERENCE_SW_NEW_FEATURES = 'SW_NEW_FEATURES';
export const USER_PREFERENCE_DEVICE_TABLE_COLUMNS = 'DEVICE_TABLE_COLUMNS';

// BE global preferences
export const GLOBAL_PREFERENCE_FEATURE_FLAG_KEY = 'FEATURE_FLAGS';
